import { render } from "./shareChannel.vue?vue&type=template&id=5abee0ca"
import script from "./shareChannel.vue?vue&type=script&lang=js"
export * from "./shareChannel.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/shareChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5abee0ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5abee0ca', __exports__)) {
    console.log('reload')
    api.reload('5abee0ca', __exports__)
  }
  
  module.hot.accept("./shareChannel.vue?vue&type=template&id=5abee0ca", () => {
    console.log('re-render')
    api.rerender('5abee0ca', render)
  })

}


export default __exports__